/* global define */
define('core/services/MixpanelService',['angular',
        'core/services/ConfigurationService',
        'core/services/UserService'
], function(angular) {
    'use strict';
    return angular.module('dnaApp').service('MixpanelService', ['$rootScope','$log', '$window', '$http', '$q', '$timeout', 'ConfigurationService', 'UserService',
        function ($rootScope, $log, $window, $http, $q, $timeout, ConfigurationService, UserService) {

        // Define "super properties"
        var APP = 'dna web';
        var CULTURE_CODE = null;
        var PRODUCT = 'dna';
        var ENVIRONMENT = dna.app.environment == 'live' ? 'prod' : (dna.app.environment || 'unknown');
        var UCDMID = null;

        var mixpanelToken;
        var mixpanel;
        var mixpanelReady = false;

        function _getSuperprops() {
            var superProps = {
                'app': APP,
                'culturecode': CULTURE_CODE,
                'product': PRODUCT,
                'ucdmid': UCDMID,
                'environment': ENVIRONMENT
            }
            return superProps;
        }

        // Action - action taken by the user - click, view, etc
        // eventProperties is an object containing additional event values to be tracked
        // such as { pagename: 'dna insights', kit_id: 'BE77FD3C-2B80-4B24-A2DA-A0F334F3F0C3'}
        function _trackEvent(action, eventProperties) {
            if(mixpanelReady) {
                mixpanel.dna.track(action,eventProperties);
            }
        }

        function _waitForMixpanelInjection() {
            // In case it showed up during the time delay below
            if( $window.mixpanel ) {
                _registerMixpanel();
                return;
            }
            var unbindMPWatch = $rootScope.$watch( function() {
                return $window.mixpanel;
            }, function(newValue) {
                unbindMPWatch();
                if ($window.mixpanel) {
                    _registerMixpanel();
                } else {
                    $timeout(function() {
                        _waitForMixpanelInjection();
                    }, 500);
                }
            });
        }

        function _registerMixpanel() {
            if(!$window.mixpanel) {
                _waitForMixpanelInjection();
                return;
            }
            mixpanel = $window.mixpanel;
            mixpanel.init(mixpanelToken, {
                loaded: function(mp) {
                    mixpanel.dna.register(_getSuperprops());
                    mixpanel.dna.identify(UCDMID);
                    mixpanelReady = true;
                }
            }, 'dna');

        }

        function _loadConfig() {
            var promises = [];
            promises.push(ConfigurationService.getCurrentConfigSettings());
            promises.push($http.get('/secure/userProperties/cultureCode'));
            promises.push(UserService.getUserMiniProfile());
            $q.all(promises).then(function (values) {
                var config = values[0];
                if( config.mixpanelEnabled && config.mixpanelToken ) {
                    mixpanelToken = config.mixpanelToken;
                    var ccData = values[1];
                    var userProfile = values[2];

                    if (ccData.status === 200) {
                        CULTURE_CODE = ccData.data;
                    } else {
                        CULTURE_CODE = 'en-US';
                        $log.warn('Unable to get culture code for user - mixpanel code set to en-US');
                    }
                    UCDMID = userProfile.ucdmId;
                    _registerMixpanel();
                } else if (config.mixpanelEnabled && !config.mixpanelToken) {
                    $log.error('Mixpanel token was not provided - mixpanel tracking not available.');
                }
            });
        }

        return {
            trackEvent: _trackEvent,
            load: _loadConfig
        };
    }]);
});
